import type { MultiSelectOptions } from '@hotjar/hotsauce';

export const scopesOptions: MultiSelectOptions = [
  { value: 'visitor_lookup', label: 'User lookup & deletion', icon: undefined },
  { value: 'survey_responses', label: 'Survey responses', icon: undefined },
];
